import _objectSpread from "/data/bash/localbuild/webclient/node_modules/@babel/runtime-corejs2/helpers/esm/objectSpread2.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import axios from "axios";
import { mapGetters } from 'vuex';
export default {
  name: "about",
  props: {
    dialogVisible: {
      type: Boolean,
      default: false
    }
  },
  data: function data() {
    return {
      form: {
        port: "8484",
        checked: false,
        listChecked: false
      },
      isWin: false
    };
  },
  computed: _objectSpread({}, mapGetters(["dcmviwerurl", "userid"])),
  mounted: function mounted() {
    this.isWin = navigator.platform == "Win32" || navigator.platform == "Windows";
    this.form.port = localStorage.getItem("viewerPort") ? localStorage.getItem("viewerPort") : this.form.port;
    this.form.checked = localStorage.getItem("viewerCheck") == 'true' ? true : this.form.checked;
    this.form.listChecked = localStorage.getItem("listChecked") == 'true' ? true : this.form.listChecked;
  },
  methods: {
    close: function close() {
      this.$emit("closeDialog", false);
    },
    setPort: function setPort() {
      localStorage.setItem("viewerPort", this.form.port);
      localStorage.setItem("viewerCheck", this.form.checked);
      localStorage.setItem("listChecked", this.form.listChecked);
      this.$message({
        type: 'success',
        message: "专业阅片设置成功"
      });
      this.close();
    },
    testPort: function testPort() {
      var _this = this;

      axios.post("http://127.0.0.1:" + this.form.port + "/check?userid=" + this.userid).then(function (res) {
        if (res.data.code == 1) {
          localStorage.setItem("viewerState", true);

          _this.$message({
            type: 'success',
            message: "测试链接成功"
          });
        }
      }).catch(function (error) {
        console.log(error);
        localStorage.setItem("viewerState", false);

        _this.$message({
          type: 'error',
          message: "测试链接失败"
        });
      });
    }
  }
};